/* global Swiper, player */
// *******************************************************************************
// 1.0 - Video Slider
// *******************************************************************************

const videoSliderElements = document.querySelectorAll('[data-slider="video-slider"]');

const videoSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 600,
  watchOverflow: true,
  autoHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

videoSliderElements.forEach((el) => {
  const videoSliderParent = el.closest('.sc-video-slider');
  const arrowRight = videoSliderParent.querySelector('.arrow-right');
  const arrowLeft = videoSliderParent.querySelector('.arrow-left');

  videoSliderOptions.navigation.nextEl = arrowRight;
  videoSliderOptions.navigation.prevEl = arrowLeft;
  const videoSlider = new Swiper(el, videoSliderOptions);

  videoSlider.on('slideChange', () => {
    const activeSlide = videoSliderParent.querySelector('.swiper-slide-active');
    const videoElem = activeSlide.querySelector('.video');
    videoElem.classList.remove('is-playing');
    const videoIframe = activeSlide.querySelector('.video__iframe-container');
    const videoIframeParent = activeSlide.querySelector('.video__iframe');

    if (typeof videoIframe !== 'undefined' && videoIframe != null) {
      videoIframe.remove();
      videoIframeParent.innerHTML = "<div class='video__iframe-container'></div>";
    }
  });
});
